shadow$provide[110] = function(require,module,exports) {
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("render", {listen:["render"], render:function(event, three) {
  if (three.scene && three.camera) {
    three.renderer.render(three.scene, three.camera);
  }
},});

};